import React from 'react';
import './QuizSidebox.css';

function FullRegisterContent() {
	return (
		<>
			<section className="quizSidebox__block">
				<div className="quizSidebox__strategyTitle">Apprentice</div>
				<div className="quizSidebox__subtitle">Mentor-Student interaction</div>
				<p className="quizSidebox__para">
					Content is presented in a systematic step-by-step procedural way so a student can learn by following simple steps.
				</p>
			</section>

			<section className="quizSidebox__block">
				<div className="quizSidebox__strategyTitle">Incidental</div>
				<div className="quizSidebox__subtitle">Case Studies</div>
				<p className="quizSidebox__para">
					Content is presented in real-life scenarios or case studies and the &apos;events&apos; in the story trigger the learning experience. These events lead to incidental learning.
				</p>
			</section>

			<section className="quizSidebox__block">
				<div className="quizSidebox__strategyTitle">Deductive</div>
				<div className="quizSidebox__subtitle">Scenario based learning</div>
				<p className="quizSidebox__para">Apply the learning to real-life scenarios.</p>
			</section>

			<section className="quizSidebox__block">
				<div className="quizSidebox__strategyTitle">Inductive</div>
				<div className="quizSidebox__subtitle">Example based learning</div>
				<p className="quizSidebox__para">
					Example based learning is a teaching method that uses examples to explain a concept or idea.
				</p>
			</section>

			<section className="quizSidebox__block">
				<div className="quizSidebox__strategyTitle">Discovery</div>
				<div className="quizSidebox__subtitle">Learn through experimentation</div>
				<p className="quizSidebox__para">
					The student is given a problem and is asked to solve it using real life experiments.
				</p>
			</section>
		</>
	);
}

function CompactStrategies() {
	return (
		<>
			<div className="quizSidebox__compactLine">
				<b>Apprentice:</b>{' '}
				Mentor-Student interaction. Content is presented in a systematic step-by-step procedural way so a student can learn by following simple steps.
			</div>
			<div className="quizSidebox__compactLine">
				<b>Incidental (Case Studies):</b>{' '}
				Content is presented in real-life scenarios or case studies and the &apos;events&apos; in the story trigger the learning experience. These events lead to incidental learning.
			</div>
			<div className="quizSidebox__compactLine">
				<b>Deductive (Scenario based learning):</b>{' '}
				Apply the learning to real-life scenarios.
			</div>
			<div className="quizSidebox__compactLine">
				<b>Inductive (Example based learning):</b>{' '}
				Example based learning is a teaching method that uses examples to explain a concept or idea.
			</div>
			<div className="quizSidebox__compactLine">
				<b>Discovery (Learn through experimentation):</b>{' '}
				The student is given a problem and is asked to solve it using real life experiments.
			</div>
		</>
	);
}

function QuizSidebox({ title, variant = 'compact' }) {
	const isFull = variant === 'full';

	return (
		<div className="quizSidebox">
			<div className="quizSidebox__title">{title || 'No Title Found'}</div>
			{!isFull && (
				<div className="quizSidebox__iconWrap">
					<svg width="64" height="64" viewBox="0 0 64 64" fill="none" aria-hidden>
						<rect x="12" y="20" width="40" height="24" rx="4" fill="#E3EAFD" stroke="#1A237E" strokeWidth="2"/>
						<path d="M12 20L32 8L52 20" stroke="#1A237E" strokeWidth="2" fill="none"/>
						<path d="M32 8V40" stroke="#1A237E" strokeWidth="2"/>
						<path d="M12 44L32 56L52 44" stroke="#1A237E" strokeWidth="2" fill="none"/>
					</svg>
				</div>
			)}
			<div
				className={
					isFull
						? 'quizSidebox__definitions quizSidebox__definitions--full'
						: 'quizSidebox__definitions quizSidebox__definitions--compact'
				}
			>
				{isFull ? <FullRegisterContent /> : <CompactStrategies />}
			</div>
		</div>
	);
}

export default QuizSidebox;
